import ContentWrapper from "src/components/lib/content-wrapper/ContentWrapper";

interface CheckExpiredProps {
  label?: string;
  heading?: string;
}

const PageNotFound = ({
  heading = "404",
  label = "Page Not Found",
}: CheckExpiredProps) => {
  return (
    <div>
      <a href="#main" className="skip-to-main-content-link">Skip to main content</a>
      <header className="border-b px-2 py-4" role="navigation">
        <img className="w-60" alt="work right" src="/images/workRight_Logo.png" />
      </header>
      <ContentWrapper className="h-screen w-screen flex items-center justify-center" role="main">
      <div className="flex-col items-center justify-center text-center grid grid-cols-1 gap-x-4">
        <div id="main">
          <h1 className="text-black font-inter text-7xl font-normal leading-normal">
            {heading}
          </h1>
          <h3 className="text-black font-inter text-2xl font-bold leading-normal">
            {label}
          </h3>
          <p className="text-black font-inter  font-normal leading-normal mt-1">
            We couldn’t find any details for the provided check. The link may be
            invalid or expired.
          </p>
          <p className="text-black font-inter  font-normal leading-normal mt-3">
            Please ensure the URL is correct, or contact support if the issue
            persists.
          </p>
        </div>
      </div>
    </ContentWrapper>
    </div>
    
  );
};

export default PageNotFound;
